import { useEffect, useState } from 'react';
import { getJSON, money, when } from './api';

// Every round (or sportsbook ticket) one player played on one game.
export const RoundsList = ({ userId, gameId, period }) => {
    const [rows, setRows] = useState(null);
    useEffect(() => {
        setRows(null);
        getJSON(`/admin/players/${userId}/games/${gameId}/rounds?period=${period}`).then((d) => setRows(d.rounds)).catch(() => setRows([]));
    }, [userId, gameId, period]);
    if (!rows) return <p className="text-xs text-zinc-500 py-4 text-center">Loading rounds…</p>;
    if (!rows.length) return <p className="text-xs text-zinc-500 py-4 text-center" data-testid="rounds-empty">No rounds in this period.</p>;
    return (
        <div className="max-h-80 overflow-y-auto rounded-lg border border-white/10" data-testid="rounds-list">
            <table className="w-full text-xs">
                <thead className="sticky top-0 bg-zinc-950 text-zinc-500"><tr><th className="text-left p-2">Time (CT)</th><th className="text-right p-2">Bet</th><th className="text-right p-2">Won</th><th className="text-left p-2">Detail</th></tr></thead>
                <tbody>
                    {rows.map((r) => (
                        <tr key={r.id} className="border-t border-white/5 text-zinc-200" data-testid={`round-row-${r.id}`}>
                            <td className="p-2 whitespace-nowrap">{when(r.time)}</td>
                            <td className="p-2 text-right font-mono">{money(r.bet)}</td>
                            <td className={`p-2 text-right font-mono ${r.won > 0 ? 'text-emerald-300' : 'text-zinc-500'}`}>{money(r.won)}</td>
                            <td className="p-2 text-zinc-400">{[r.event, r.detail, r.status && r.status.toUpperCase()].filter(Boolean).join(' · ')}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
